export default "__VITE_ASSET__Bk0eHJon__"